export default {
  title: 'Platform dashboard',
  anonymousUsers: 'Anonymous users',
  loggedInUsers: 'Logged-in users',
  shops: 'Shops',
  teams: 'Teams',
  shopsHeading: 'Shops',
  shopId: 'Shop ID',
  created: 'Created',
  loadError: 'Failed to load dashboard data',
  noShops: 'No shops yet',
}
